import { createPopularUsCitiesLinks } from '@tenants/definitions/exp/shared/internal-links';
import { createPopularUsStatesLinks } from '@tenants/definitions/exp/shared/internal-links';
import { HomeConfig } from '@tenants/types/tenant';
import { ROOT_PATH_SUFFIX } from 'data/addresses/go-search/types';
import { LOCALE_HOME_PATHS } from 'types/locales';

export function createHomeConfig(rootPathSuffix: string = ROOT_PATH_SUFFIX): HomeConfig {
  const homeConfig = {
    heroVideo: '/us-hero-1.mp4',
    joinLink: 'https://join.exprealty.com',
    joinUsSection:{
      title: 'Why Join',
      title2: 'eXp Realty?',
      description: 'When you join eXp Realty, you become part of a global family of agents and partners dedicated to transforming the real estate experience. Learn more about how we empower our agents with world-class education, strategic partnership and stock awards.',
      imageUrl: '/assets/images/exp-homepage/why-join-exp-us.png',
      buttonText: 'Learn More',
      link: '/join-exp',
    },
    internalLinks: [
      createPopularUsCitiesLinks(rootPathSuffix),
      createPopularUsStatesLinks(rootPathSuffix),
    ],
    contentCards: {
      sectionTitleParts: [LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_FIRST, LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_SECOND, LOCALE_HOME_PATHS.CONTENT_CARDS_SECTION_TITLE_PARTS_THIRD],
      cards: [
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_BUY_WITH_US_TITLE,
          image: '/next/assets/images/content-cards/us-buy.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#163259',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_BUY_WITH_US_CONTENT,
          link: '/search?openSearch=true',
          desktopTransform: 'rotate(-5deg)',
          tabletTransform: 'none',
          rounded: true,
          altText: 'A man with his hair in a bun hugging a woman outside of a modern building.',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SELL_WITH_US_TITLE,
          image: '/next/assets/images/content-cards/us-sell.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#6C82A0',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_SELL_WITH_US_CONTENT,
          link: '/sell',
          tabletTransform: 'translateY(3em)',
          translateYTablet: '50',
          altText: 'A smiling family, with two kids playing inside a cardboard box',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_FIND_AN_AGENT_TITLE,
          image: '/next/assets/images/content-cards/us-agent.jpg',
          titleColor: '#163259',
          backgroundColor: '#DAE0E7',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_FIND_AN_AGENT_CONTENT,
          link: '/agents-search',
          desktopTransform: 'rotate(2deg) translateY(-1.5em)',
          tabletTransform: 'none',
          translateYDesktop: '-20',
          altText: 'A group of professionals sitting around a table, engaged in conversation.',
        },
        {
          title: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_CASH_OFFERS_TITLE,
          image: '/next/assets/images/content-cards/us-cash.jpg',
          titleColor: '#6D6F7C',
          backgroundColor: '#EEEEEE',
          content: LOCALE_HOME_PATHS.CONTENT_CARDS_CARDS_CASH_OFFERS_CONTENT,
          link: 'https://expressoffers.com/',
          desktopTransform: 'rotate(7deg) translateY(2em)',
          tabletTransform: 'translateY(3em)',
          translateYDesktop: '40',
          translateYTablet: '50',
          rounded: true,
          altText: 'Close-up of hands typing on a laptop.',
        },
      ],
    },
  };
  return homeConfig;
}